import React from "react";

const LinkRowComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default LinkRowComponent;
